// Manodayam frontend i18n bundles.
// Only the most user-facing strings are translated; the rest fall back to English.

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "ta", label: "Tamil", native: "தமிழ்" },
  { code: "te", label: "Telugu", native: "తెలుగు" },
  { code: "kn", label: "Kannada", native: "ಕನ್ನಡ" },
  { code: "mr", label: "Marathi", native: "मराठी" },
  { code: "bn", label: "Bengali", native: "বাংলা" },
];

const B = {
  en: {
    brand_tag: "Voice · Mind · Care",
    "nav.home": "Home",
    "nav.assess": "Assess",
    "nav.lab": "Lab",
    "nav.experts": "Experts",
    "nav.care": "Care",
    "nav.me": "My Page",
    "landing.tagline": "A voice-first well-being screen",
    "landing.title": "Where Voice Maps The State of Mind",
    "landing.subtitle":
      "Manodayam blends voice acoustic biomarkers with clinically validated questionnaires to gently screen for mental health and cognitive risk — and connects you to the right care.",
    "landing.cta_primary": "Begin a screening",
    "landing.cta_secondary": "I already have an account",
    "landing.apply_link": "Apply as a specialist",
    "auth.login": "Log in",
    "auth.signup": "Get started",
    "auth.welcome_back": "Welcome back",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.sign_in": "Sign in",
    "auth.new_here": "New here?",
    "auth.create_account": "Create an account",
    "home.greeting": "Namaste",
    "home.hero_title": "Ready to check in with yourself today?",
    "home.hero_sub": "A short voice check-in or a Voice Lab questionnaire — you choose the entry point.",
    "home.start_voice": "Start a voice check-in",
    "home.open_voicelab": "Open Voice Lab",
    "home.latest_report": "Latest report",
    "home.view_report": "View report",
    "quick.assess": "Voice Assessment",
    "quick.assess_sub": "30-second guided prompts",
    "quick.voicelab": "Voice Lab",
    "quick.voicelab_sub": "PHQ-9 · GAD-7 · MoCA",
    "quick.experts": "Clinical Experts",
    "quick.experts_sub": "Book a consultation",
    "quick.therapies": "Therapies & Packages",
    "quick.therapies_sub": "Explore care journeys",
    "voicelab.title": "Standardized questionnaires",
    "voicelab.subtitle":
      "Complete any questionnaire to complement your voice assessment. Each shows an individual band and contributes to a combined summary.",
    "voicelab.combined": "Combined Voice Lab summary",
    "therapies.title": "Curated pathways",
    "therapies.subtitle": "Bundled programmes combining clinical and adjunctive support.",
    "therapies.buy": "Buy package",
    "therapies.owned": "You own this",
    "therapies.individual": "Adjunctive care catalogue",
    "experts.title": "Verified specialists",
    "experts.subtitle": "Every expert is manually reviewed by our team before being listed.",
    "assess.prompt1": "How is your work going?",
    "assess.prompt2": "Describe your memories of childhood.",
    "assess.play": "Play prompt",
    "assess.stop": "Stop",
    "assess.read_aloud": "Read out loud",
    "register.step1": "Create your account",
    "register.step1_sub": "Your profile stays private and secure.",
    "register.step2": "Your consent matters",
    "register.step2_sub": "Please confirm before we proceed.",
    "register.step3": "A short orientation",
    "register.step3_sub": "Two quick questions to anchor your assessment.",
    "register.name": "Full name",
    "register.email": "Email",
    "register.password": "Password (min 6 chars)",
    "register.phone": "Mobile number",
    "register.dob": "Date of birth",
    "register.gender": "Gender",
    "register.language": "Preferred language",
    "register.continue": "Continue",
    "register.back": "Back",
    "register.create": "Create account",
    "register.creating": "Creating…",
    "register.consent_data_title": "I consent to data collection & storage",
    "register.consent_data_body": "Your profile, assessment results and metadata are stored securely and can be deleted on request.",
    "register.consent_rec_title": "I consent to voice recording for screening",
    "register.consent_rec_body": "Short voice samples (~30s each) are analysed by our Voice Acoustic Biomarker model. You may withdraw anytime.",
    "register.orient_where": "Where are you right now?",
    "register.orient_when": "What is today's date and time?",
    "report.next": "Suggested next step",
    "report.high_title": "Please connect with a clinical specialist",
    "report.high_body": "Given the severity, only clinical consultation is enabled from this report.",
    "report.book_clinical": "Book a clinical consult",
    "report.speak_specialist": "Speak to a specialist",
    "report.browse_therapies": "Explore therapies",
    "report.open_voicelab": "Continue in Voice Lab",
    "report.crisis": "Crisis? Vandrevala Foundation Helpline: 1860 2662 345",
    "band.normal.title": "Within normal range",
    "band.normal.body": "Your indicators look steady. Keep nurturing your daily routines — consider a mindfulness or breathwork session.",
    "band.mild.title": "Mild indicators noticed",
    "band.mild.body": "Small changes may be worth attention. Explore adjunctive therapies or Voice Lab questionnaires.",
    "band.moderate.title": "Moderate concern",
    "band.moderate.body": "We recommend consulting a clinical specialist to discuss your indicators.",
    "band.high.title": "High severity — please seek support",
    "band.high.body": "Please book a clinical consultation. If you feel unsafe, contact Vandrevala Foundation Helpline: 1860 2662 345.",
  },
  hi: {
    brand_tag: "आवाज़ · मन · देखभाल",
    "nav.home": "होम",
    "nav.assess": "जाँच",
    "nav.lab": "लैब",
    "nav.experts": "विशेषज्ञ",
    "nav.care": "देखभाल",
    "nav.me": "मेरा पेज",
    "landing.tagline": "एक आवाज़-प्रथम कल्याण स्क्रीनिंग",
    "landing.title": "आपकी आवाज़, आपके मन की स्थिति।",
    "landing.subtitle":
      "मनोदयम् आवाज़ के ध्वनिक बायोमार्कर और चिकित्सकीय रूप से मान्य प्रश्नावलियों को मिलाकर मानसिक स्वास्थ्य और संज्ञानात्मक जोखिम की सौम्य जाँच करता है — और आपको सही देखभाल से जोड़ता है।",
    "landing.cta_primary": "स्क्रीनिंग शुरू करें",
    "landing.cta_secondary": "मेरा पहले से खाता है",
    "landing.apply_link": "विशेषज्ञ के रूप में आवेदन करें",
    "auth.login": "लॉग इन",
    "auth.signup": "शुरू करें",
    "auth.welcome_back": "वापस स्वागत है",
    "auth.email": "ईमेल",
    "auth.password": "पासवर्ड",
    "auth.sign_in": "साइन इन",
    "auth.new_here": "नए हैं?",
    "auth.create_account": "खाता बनाएँ",
    "home.greeting": "नमस्ते",
    "home.hero_title": "आज खुद से जुड़ने के लिए तैयार हैं?",
    "home.hero_sub": "एक छोटी आवाज़ का नमूना या एक Voice Lab प्रश्नावली — आप चुनें।",
    "home.start_voice": "आवाज़ स्क्रीनिंग शुरू करें",
    "home.open_voicelab": "Voice Lab खोलें",
    "home.latest_report": "नवीनतम रिपोर्ट",
    "home.view_report": "रिपोर्ट देखें",
    "quick.assess": "आवाज़ मूल्यांकन",
    "quick.assess_sub": "30 सेकंड के निर्देशित प्रश्न",
    "quick.voicelab": "Voice Lab",
    "quick.voicelab_sub": "PHQ-9 · GAD-7 · MoCA",
    "quick.experts": "क्लिनिकल विशेषज्ञ",
    "quick.experts_sub": "परामर्श बुक करें",
    "quick.therapies": "थेरेपी और पैकेज",
    "quick.therapies_sub": "देखभाल यात्राएँ देखें",
    "voicelab.title": "मानकीकृत प्रश्नावलियाँ",
    "voicelab.subtitle": "अपनी आवाज़ मूल्यांकन के साथ किसी भी प्रश्नावली को पूरा करें।",
    "voicelab.combined": "संयुक्त Voice Lab सारांश",
    "therapies.title": "क्यूरेटेड यात्राएँ",
    "therapies.subtitle": "क्लिनिकल और सहायक देखभाल को मिलाकर बंडल किए गए कार्यक्रम।",
    "therapies.buy": "पैकेज खरीदें",
    "therapies.owned": "आपके पास है",
    "therapies.individual": "सहायक देखभाल सूची",
    "experts.title": "सत्यापित विशेषज्ञ",
    "experts.subtitle": "हर विशेषज्ञ को हमारी टीम मैन्युअल रूप से सत्यापित करती है।",
    "register.step1": "अपना खाता बनाएँ",
    "register.step1_sub": "आपकी जानकारी निजी और सुरक्षित रहेगी।",
    "register.step2": "आपकी सहमति आवश्यक है",
    "register.step2_sub": "आगे बढ़ने से पहले पुष्टि करें।",
    "register.step3": "छोटा-सा परिचय",
    "register.step3_sub": "मूल्यांकन को स्थिर करने के लिए दो त्वरित प्रश्न।",
    "register.name": "पूरा नाम",
    "register.email": "ईमेल",
    "register.password": "पासवर्ड (न्यूनतम 6 अक्षर)",
    "register.phone": "मोबाइल नंबर",
    "register.dob": "जन्म तिथि",
    "register.gender": "लिंग",
    "register.language": "पसंदीदा भाषा",
    "register.continue": "जारी रखें",
    "register.back": "पीछे",
    "register.create": "खाता बनाएँ",
    "register.creating": "बना रहे हैं…",
    "register.consent_data_title": "मैं डेटा संग्रह और भंडारण के लिए सहमत हूँ",
    "register.consent_data_body": "आपकी प्रोफ़ाइल, मूल्यांकन परिणाम और मेटाडेटा सुरक्षित रूप से संग्रहीत हैं और अनुरोध पर हटाए जा सकते हैं।",
    "register.consent_rec_title": "मैं स्क्रीनिंग के लिए आवाज़ रिकॉर्डिंग की सहमति देता/देती हूँ",
    "register.consent_rec_body": "छोटे आवाज़ नमूने (~30s प्रत्येक) VAB मॉडल द्वारा विश्लेषित होते हैं।",
    "register.orient_where": "आप इस समय कहाँ हैं?",
    "register.orient_when": "आज की तिथि और समय क्या है?",
    "report.next": "अगला सुझाया कदम",
    "report.high_title": "कृपया क्लिनिकल विशेषज्ञ से जुड़ें",
    "report.high_body": "गंभीरता को देखते हुए, केवल क्लिनिकल परामर्श सक्षम है।",
    "report.book_clinical": "क्लिनिकल परामर्श बुक करें",
    "report.speak_specialist": "विशेषज्ञ से बात करें",
    "report.browse_therapies": "थेरेपी देखें",
    "report.open_voicelab": "Voice Lab में जारी रखें",
    "report.crisis": "संकट में? Vandrevala Foundation हेल्पलाइन: 1860 2662 345",
    "band.normal.title": "सामान्य सीमा में",
    "band.normal.body": "आपके संकेतक स्थिर लगते हैं। दैनिक अभ्यास जारी रखें।",
    "band.mild.title": "हल्के संकेतक",
    "band.mild.body": "थोड़े बदलाव पर ध्यान दें। सहायक थेरेपी या Voice Lab प्रश्नावलियाँ देखें।",
    "band.moderate.title": "मध्यम चिंता",
    "band.moderate.body": "हम क्लिनिकल विशेषज्ञ से परामर्श करने की सलाह देते हैं।",
    "band.high.title": "उच्च गंभीरता — कृपया सहायता लें",
    "band.high.body": "कृपया क्लिनिकल परामर्श बुक करें। असुरक्षित महसूस करें तो Vandrevala हेल्पलाइन: 1860 2662 345.",
    "assess.prompt1": "आपका काम कैसा चल रहा है?",
    "assess.prompt2": "अपनी बचपन की यादों के बारे में बताइए।",
    "assess.play": "प्रॉम्प्ट सुनें",
    "assess.stop": "रोकें",
    "assess.read_aloud": "ज़ोर से पढ़ें",
  },
  ta: {
    brand_tag: "குரல் · மனம் · பராமரிப்பு",
    "nav.home": "முகப்பு",
    "nav.assess": "மதிப்பீடு",
    "nav.lab": "ஆய்வகம்",
    "nav.experts": "நிபுணர்கள்",
    "nav.care": "பராமரிப்பு",
    "nav.me": "எனது பக்கம்",
    "landing.tagline": "குரல் முதன்மை நல்வாழ்வு பரிசோதனை",
    "landing.title": "உங்கள் மனநிலை, உங்கள் குரலில் கேட்கப்படுகிறது.",
    "landing.subtitle":
      "மனோதயம் குரல் ஒலியியல் பயோமார்க்கர்களை மனநலம் மற்றும் அறிதிறன் ஆபத்தை மென்மையாக பரிசோதிக்க இணைக்கிறது.",
    "landing.cta_primary": "பரிசோதனையைத் தொடங்கு",
    "landing.cta_secondary": "எனக்கு ஏற்கனவே கணக்கு உள்ளது",
    "landing.apply_link": "நிபுணராக விண்ணப்பிக்கவும்",
    "auth.login": "உள்நுழை",
    "auth.signup": "தொடங்கு",
    "auth.welcome_back": "மீண்டும் வரவேற்கிறோம்",
    "auth.email": "மின்னஞ்சல்",
    "auth.password": "கடவுச்சொல்",
    "auth.sign_in": "உள்நுழை",
    "auth.new_here": "புதியவரா?",
    "auth.create_account": "கணக்கை உருவாக்கு",
    "home.greeting": "வணக்கம்",
    "home.hero_title": "இன்று உங்களுடன் இணைய தயாரா?",
    "home.hero_sub": "ஒரு குரல் மாதிரி அல்லது Voice Lab கேள்வியை தேர்வு செய்யுங்கள்.",
    "home.start_voice": "குரல் பரிசோதனை",
    "home.open_voicelab": "Voice Lab திற",
    "home.latest_report": "சமீபத்திய அறிக்கை",
    "home.view_report": "அறிக்கையை பார்க்க",
    "quick.assess": "குரல் மதிப்பீடு",
    "quick.assess_sub": "30 வினாடி வழிகாட்டி",
    "quick.voicelab": "Voice Lab",
    "quick.voicelab_sub": "PHQ-9 · GAD-7 · MoCA",
    "quick.experts": "மருத்துவ நிபுணர்கள்",
    "quick.experts_sub": "ஆலோசனையை பதிவு செய்",
    "quick.therapies": "சிகிச்சை & தொகுப்புகள்",
    "quick.therapies_sub": "பராமரிப்புப் பயணங்களை ஆராயுங்கள்",
    "voicelab.title": "தரப்படுத்தப்பட்ட கேள்விப்பட்டியல்கள்",
    "voicelab.subtitle": "ஏதேனும் ஒரு கேள்விப்பட்டியலை நிறைவு செய்யுங்கள்.",
    "voicelab.combined": "இணைந்த Voice Lab சுருக்கம்",
    "therapies.title": "தேர்ந்தெடுத்த பாதைகள்",
    "therapies.subtitle": "மருத்துவ மற்றும் துணை பராமரிப்பை இணைத்த தொகுப்புகள்.",
    "therapies.buy": "தொகுப்பை வாங்கு",
    "therapies.owned": "உங்களுக்குச் சொந்தமானது",
    "therapies.individual": "துணை பராமரிப்புப் பட்டியல்",
    "experts.title": "சரிபார்க்கப்பட்ட நிபுணர்கள்",
    "experts.subtitle": "ஒவ்வொரு நிபுணரும் எங்கள் குழுவால் மதிப்பாய்வு செய்யப்படுகிறார்.",
    "register.step1": "உங்கள் கணக்கை உருவாக்குங்கள்", "register.step1_sub": "உங்கள் தகவல்கள் ரகசியமாகவும் பாதுகாப்பாகவும் இருக்கும்.",
    "register.step2": "உங்கள் ஒப்புதல் முக்கியம்", "register.step2_sub": "தொடர்வதற்கு முன் உறுதிப்படுத்துங்கள்.",
    "register.step3": "சிறு அறிமுகம்", "register.step3_sub": "மதிப்பீட்டிற்கு இரண்டு விரைவான கேள்விகள்.",
    "register.name": "முழு பெயர்", "register.email": "மின்னஞ்சல்", "register.password": "கடவுச்சொல் (குறைந்தது 6)", "register.phone": "மொபைல் எண்",
    "register.dob": "பிறந்த தேதி", "register.gender": "பாலினம்", "register.language": "விருப்ப மொழி",
    "register.continue": "தொடர்க", "register.back": "பின்", "register.create": "கணக்கை உருவாக்கு",
    "register.creating": "உருவாக்குகிறது…",
    "register.consent_data_title": "தரவு சேகரிப்புக்கு நான் ஒப்புக்கொள்கிறேன்",
    "register.consent_data_body": "உங்கள் விவரங்கள் பாதுகாப்பாக சேமிக்கப்பட்டு தேவைப்பட்டால் நீக்கப்படலாம்.",
    "register.consent_rec_title": "குரல் பதிவுக்கு நான் ஒப்புக்கொள்கிறேன்",
    "register.consent_rec_body": "சிறு குரல் மாதிரிகள் VAB மாதிரியால் பகுப்பாய்வு செய்யப்படுகின்றன.",
    "register.orient_where": "நீங்கள் இப்போது எங்கே இருக்கிறீர்கள்?", "register.orient_when": "இன்றைய தேதி மற்றும் நேரம்?",
    "report.next": "பரிந்துரைக்கப்பட்ட அடுத்த படி",
    "report.high_title": "மருத்துவ நிபுணரைத் தொடர்பு கொள்ளுங்கள்",
    "report.high_body": "தீவிரத்தை கருத்தில் கொண்டு, மருத்துவ ஆலோசனை மட்டுமே இயக்கப்பட்டுள்ளது.",
    "report.book_clinical": "மருத்துவ ஆலோசனையை பதிவு செய்",
    "report.speak_specialist": "நிபுணரிடம் பேசு", "report.browse_therapies": "சிகிச்சைகளை பார்",
    "report.open_voicelab": "Voice Lab-இல் தொடர்",
    "report.crisis": "நெருக்கடி? Vandrevala Foundation உதவி எண்: 1860 2662 345",
    "band.normal.title": "சாதாரண வரம்பில்",
    "band.normal.body": "உங்கள் குறிகாட்டிகள் நிலையானவை. தினசரி பயிற்சிகளைத் தொடருங்கள்.",
    "band.mild.title": "லேசான குறிகாட்டிகள்",
    "band.mild.body": "சிறிய மாற்றங்களுக்கு கவனம் செலுத்துங்கள்.",
    "band.moderate.title": "மிதமான கவலை",
    "band.moderate.body": "மருத்துவ நிபுணருடன் ஆலோசிக்குமாறு நாங்கள் பரிந்துரைக்கிறோம்.",
    "band.high.title": "அதிக தீவிரம் — உதவி பெறுங்கள்",
    "band.high.body": "மருத்துவ ஆலோசனையை பதிவு செய்யுங்கள். பாதுகாப்பற்றதாக உணர்ந்தால் Vandrevala உதவி எண்: 1860 2662 345.",
    "assess.prompt1": "உங்கள் வேலை எப்படி நடக்கிறது?",
    "assess.prompt2": "உங்கள் குழந்தை பருவ நினைவுகளைப் பற்றி கூறுங்கள்.",
    "assess.play": "கேள்வியை கேளுங்கள்",
    "assess.stop": "நிறுத்து",
    "assess.read_aloud": "சத்தமாக படியுங்கள்",
  },
  te: {
    brand_tag: "వాయిస్ · మనస్సు · సంరక్షణ",
    "nav.home": "హోమ్", "nav.assess": "పరిశీలన", "nav.lab": "ల్యాబ్", "nav.experts": "నిపుణులు", "nav.care": "సంరక్షణ", "nav.me": "నా పేజీ",
    "landing.tagline": "వాయిస్-ఫస్ట్ మానసిక ఆరోగ్య పరీక్ష",
    "landing.title": "మీ వాయిస్, మీ మనస్సు స్థితి.",
    "landing.subtitle": "మనోదయం వాయిస్ అకౌస్టిక్ బయోమార్కర్‌లను ఉపయోగించి మానసిక & జ్ఞాన నష్టం స్క్రీనింగ్ చేస్తుంది.",
    "landing.cta_primary": "స్క్రీనింగ్ ప్రారంభించండి", "landing.cta_secondary": "నాకు ఇప్పటికే ఖాతా ఉంది",
    "landing.apply_link": "నిపుణుడిగా దరఖాస్తు చేయండి",
    "auth.login": "సైన్ ఇన్", "auth.signup": "ప్రారంభించండి",
    "auth.welcome_back": "మళ్ళీ స్వాగతం", "auth.email": "ఇమెయిల్", "auth.password": "పాస్‌వర్డ్",
    "auth.sign_in": "సైన్ ఇన్", "auth.new_here": "కొత్తగా వచ్చారా?", "auth.create_account": "ఖాతా సృష్టించండి",
    "home.greeting": "నమస్తే", "home.hero_title": "ఈరోజు మిమ్మల్ని పరిశీలించుకోవడానికి సిద్ధమా?",
    "home.hero_sub": "చిన్న వాయిస్ నమూనా లేదా Voice Lab ప్రశ్నపత్రం — మీరు ఎంచుకోండి.",
    "home.start_voice": "వాయిస్ స్క్రీనింగ్ ప్రారంభించండి", "home.open_voicelab": "Voice Lab తెరవండి",
    "home.latest_report": "తాజా నివేదిక", "home.view_report": "నివేదిక చూడండి",
    "quick.assess": "వాయిస్ మూల్యాంకనం", "quick.assess_sub": "30 సెకన్ల మార్గదర్శక ప్రశ్నలు",
    "quick.voicelab": "Voice Lab", "quick.voicelab_sub": "PHQ-9 · GAD-7 · MoCA",
    "quick.experts": "క్లినికల్ నిపుణులు", "quick.experts_sub": "సంప్రదింపు బుక్ చేయండి",
    "quick.therapies": "థెరపీలు & ప్యాకేజీలు", "quick.therapies_sub": "సంరక్షణ మార్గాలను అన్వేషించండి",
    "voicelab.title": "ప్రామాణిక ప్రశ్నపత్రాలు",
    "voicelab.subtitle": "మీ వాయిస్ మూల్యాంకనానికి పూరకంగా ఏదైనా ప్రశ్నపత్రం పూర్తి చేయండి.",
    "voicelab.combined": "సంయుక్త Voice Lab సారాంశం",
    "therapies.title": "ఎంపిక చేసిన మార్గాలు",
    "therapies.subtitle": "క్లినికల్ మరియు అనుబంధ సంరక్షణను కలిపిన ప్యాకేజీలు.",
    "therapies.buy": "ప్యాకేజీ కొనండి", "therapies.owned": "మీ దగ్గర ఉంది",
    "therapies.individual": "అనుబంధ సంరక్షణ జాబితా",
    "experts.title": "ధృవీకరించబడిన నిపుణులు",
    "experts.subtitle": "ప్రతి నిపుణుడు మా బృందంచే మాన్యువల్‌గా ధృవీకరించబడతారు.",
    "register.step1": "మీ ఖాతాను సృష్టించండి", "register.step1_sub": "మీ సమాచారం గోప్యంగా, సురక్షితంగా ఉంటుంది.",
    "register.step2": "మీ అనుమతి ముఖ్యం", "register.step2_sub": "కొనసాగే ముందు నిర్ధారించండి.",
    "register.step3": "చిన్న పరిచయం", "register.step3_sub": "మూల్యాంకనానికి రెండు త్వరిత ప్రశ్నలు.",
    "register.name": "పూర్తి పేరు", "register.email": "ఇమెయిల్", "register.password": "పాస్‌వర్డ్ (కనీసం 6 అక్షరాలు)", "register.phone": "మొబైల్ నంబర్",
    "register.dob": "పుట్టిన తేదీ", "register.gender": "లింగం", "register.language": "ఇష్టపడే భాష",
    "register.continue": "కొనసాగించండి", "register.back": "వెనుకకు", "register.create": "ఖాతా సృష్టించండి",
    "register.creating": "సృష్టిస్తోంది…",
    "register.consent_data_title": "డేటా సేకరణ & నిల్వకు నేను అంగీకరిస్తున్నాను",
    "register.consent_data_body": "మీ ప్రొఫైల్, మూల్యాంకన ఫలితాలు సురక్షితంగా నిల్వ చేయబడతాయి.",
    "register.consent_rec_title": "స్క్రీనింగ్‌కు వాయిస్ రికార్డింగ్‌కు అంగీకరిస్తున్నాను",
    "register.consent_rec_body": "చిన్న వాయిస్ నమూనాలు VAB మోడల్‌చే విశ్లేషించబడతాయి.",
    "register.orient_where": "మీరు ఇప్పుడు ఎక్కడ ఉన్నారు?", "register.orient_when": "ఈరోజు తేదీ మరియు సమయం ఏమిటి?",
    "report.next": "సూచించిన తదుపరి దశ",
    "report.high_title": "దయచేసి క్లినికల్ నిపుణుడితో సంప్రదించండి",
    "report.high_body": "తీవ్రత దృష్ట్యా, ఈ నివేదిక నుండి క్లినికల్ సంప్రదింపు మాత్రమే ప్రారంభించబడింది.",
    "report.book_clinical": "క్లినికల్ సంప్రదింపు బుక్ చేయండి",
    "report.speak_specialist": "నిపుణుడితో మాట్లాడండి",
    "report.browse_therapies": "థెరపీలను అన్వేషించండి",
    "report.open_voicelab": "Voice Lab లో కొనసాగించండి",
    "report.crisis": "సంక్షోభం? Vandrevala Foundation హెల్ప్‌లైన్: 1860 2662 345",
    "band.normal.title": "సాధారణ పరిధిలో",
    "band.normal.body": "మీ సూచికలు స్థిరంగా కనిపిస్తున్నాయి. దైనందిన అభ్యాసాలను కొనసాగించండి.",
    "band.mild.title": "తేలికపాటి సూచికలు",
    "band.mild.body": "చిన్న మార్పులకు దృష్టి పెట్టండి. అనుబంధ థెరపీలు లేదా Voice Lab అన్వేషించండి.",
    "band.moderate.title": "మధ్యస్థ ఆందోళన",
    "band.moderate.body": "క్లినికల్ నిపుణుడితో సంప్రదించమని మేము సిఫార్సు చేస్తున్నాము.",
    "band.high.title": "అధిక తీవ్రత — దయచేసి సహాయం తీసుకోండి",
    "band.high.body": "క్లినికల్ సంప్రదింపు బుక్ చేయండి. అసురక్షితంగా అనిపిస్తే Vandrevala హెల్ప్‌లైన్: 1860 2662 345.",
    "assess.prompt1": "మీ పని ఎలా సాగుతోంది?",
    "assess.prompt2": "మీ చిన్ననాటి జ్ఞాపకాలను వివరించండి.",
    "assess.play": "ప్రాంప్ట్ వినండి",
    "assess.stop": "ఆపు",
    "assess.read_aloud": "బిగ్గరగా చదవండి",
  },
  kn: {
    brand_tag: "ಧ್ವನಿ · ಮನಸ್ಸು · ಆರೈಕೆ",
    "nav.home": "ಮುಖಪುಟ", "nav.assess": "ಪರೀಕ್ಷೆ", "nav.lab": "ಲ್ಯಾಬ್", "nav.experts": "ತಜ್ಞರು", "nav.care": "ಆರೈಕೆ", "nav.me": "ನನ್ನ ಪುಟ",
    "landing.tagline": "ಧ್ವನಿ-ಮೊದಲ ಮಾನಸಿಕ ಆರೋಗ್ಯ ಪರೀಕ್ಷೆ",
    "landing.title": "ನಿಮ್ಮ ಧ್ವನಿ, ನಿಮ್ಮ ಮನಸ್ಸಿನ ಸ್ಥಿತಿ.",
    "landing.subtitle": "ಮನೋದಯಂ ಧ್ವನಿ ಬಯೋಮಾರ್ಕರ್‌ಗಳನ್ನು ಬಳಸಿ ಮಾನಸಿಕ ಮತ್ತು ಅರಿವಿನ ಆರೋಗ್ಯ ಪರೀಕ್ಷೆ ಮಾಡುತ್ತದೆ.",
    "landing.cta_primary": "ಪರೀಕ್ಷೆ ಪ್ರಾರಂಭಿಸಿ", "landing.cta_secondary": "ನನಗೆ ಈಗಾಗಲೇ ಖಾತೆ ಇದೆ",
    "landing.apply_link": "ತಜ್ಞರಾಗಿ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
    "auth.login": "ಸೈನ್ ಇನ್", "auth.signup": "ಪ್ರಾರಂಭಿಸಿ",
    "auth.welcome_back": "ಮತ್ತೆ ಸ್ವಾಗತ", "auth.email": "ಇಮೇಲ್", "auth.password": "ಪಾಸ್‌ವರ್ಡ್",
    "auth.sign_in": "ಸೈನ್ ಇನ್", "auth.new_here": "ಹೊಸಬರೇ?", "auth.create_account": "ಖಾತೆ ರಚಿಸಿ",
    "home.greeting": "ನಮಸ್ಕಾರ", "home.hero_title": "ಇಂದು ನಿಮ್ಮನ್ನು ಪರಿಶೀಲಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
    "home.hero_sub": "ಸಣ್ಣ ಧ್ವನಿ ಮಾದರಿ ಅಥವಾ Voice Lab ಪ್ರಶ್ನಾವಳಿ ಆಯ್ಕೆ ಮಾಡಿ.",
    "home.start_voice": "ಧ್ವನಿ ಪರೀಕ್ಷೆ ಪ್ರಾರಂಭಿಸಿ", "home.open_voicelab": "Voice Lab ತೆರೆಯಿರಿ",
    "home.latest_report": "ಇತ್ತೀಚಿನ ವರದಿ", "home.view_report": "ವರದಿ ವೀಕ್ಷಿಸಿ",
    "quick.assess": "ಧ್ವನಿ ಮೌಲ್ಯಮಾಪನ", "quick.assess_sub": "30 ಸೆಕೆಂಡ್‌ಗಳ ಮಾರ್ಗದರ್ಶಿ ಪ್ರಶ್ನೆಗಳು",
    "quick.voicelab": "Voice Lab", "quick.voicelab_sub": "PHQ-9 · GAD-7 · MoCA",
    "quick.experts": "ಕ್ಲಿನಿಕಲ್ ತಜ್ಞರು", "quick.experts_sub": "ಸಮಾಲೋಚನೆ ಬುಕ್ ಮಾಡಿ",
    "quick.therapies": "ಥೆರಪಿ & ಪ್ಯಾಕೇಜ್‌ಗಳು", "quick.therapies_sub": "ಆರೈಕೆ ಪ್ರಯಾಣಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
    "voicelab.title": "ಪ್ರಮಾಣಿತ ಪ್ರಶ್ನಾವಳಿಗಳು", "voicelab.subtitle": "ಯಾವುದೇ ಪ್ರಶ್ನಾವಳಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ.",
    "voicelab.combined": "ಸಂಯೋಜಿತ Voice Lab ಸಾರಾಂಶ",
    "therapies.title": "ಆಯ್ದ ಮಾರ್ಗಗಳು", "therapies.subtitle": "ಕ್ಲಿನಿಕಲ್ ಮತ್ತು ಪೂರಕ ಆರೈಕೆಯನ್ನು ಒಟ್ಟುಗೂಡಿಸಿದ ಪ್ಯಾಕೇಜ್‌ಗಳು.",
    "therapies.buy": "ಪ್ಯಾಕೇಜ್ ಖರೀದಿಸಿ", "therapies.owned": "ನಿಮಗೆ ಸೇರಿದೆ",
    "therapies.individual": "ಪೂರಕ ಆರೈಕೆ ಪಟ್ಟಿ",
    "experts.title": "ಪರಿಶೀಲಿಸಿದ ತಜ್ಞರು",
    "experts.subtitle": "ಪ್ರತಿ ತಜ್ಞರನ್ನು ನಮ್ಮ ತಂಡವು ಮಾನ್ಯುವಲಿ ಪರಿಶೀಲಿಸುತ್ತದೆ.",
    "register.step1": "ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸಿ", "register.step1_sub": "ನಿಮ್ಮ ಮಾಹಿತಿ ಗೌಪ್ಯ ಮತ್ತು ಸುರಕ್ಷಿತ.",
    "register.step2": "ನಿಮ್ಮ ಒಪ್ಪಿಗೆ ಮುಖ್ಯ", "register.step2_sub": "ಮುಂದುವರಿಯುವ ಮೊದಲು ದೃಢೀಕರಿಸಿ.",
    "register.step3": "ಸಣ್ಣ ಪರಿಚಯ", "register.step3_sub": "ಮೌಲ್ಯಮಾಪನಕ್ಕೆ ಎರಡು ತ್ವರಿತ ಪ್ರಶ್ನೆಗಳು.",
    "register.name": "ಪೂರ್ಣ ಹೆಸರು", "register.email": "ಇಮೇಲ್", "register.password": "ಪಾಸ್‌ವರ್ಡ್ (ಕನಿಷ್ಠ 6)", "register.phone": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    "register.dob": "ಜನ್ಮ ದಿನಾಂಕ", "register.gender": "ಲಿಂಗ", "register.language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "register.continue": "ಮುಂದುವರಿಸಿ", "register.back": "ಹಿಂದೆ", "register.create": "ಖಾತೆ ರಚಿಸಿ",
    "register.creating": "ರಚಿಸುತ್ತಿದೆ…",
    "register.consent_data_title": "ಡೇಟಾ ಸಂಗ್ರಹಣೆಗೆ ನಾನು ಒಪ್ಪುತ್ತೇನೆ",
    "register.consent_data_body": "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಸುರಕ್ಷಿತವಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗಿದೆ.",
    "register.consent_rec_title": "ಧ್ವನಿ ರೆಕಾರ್ಡಿಂಗ್‌ಗೆ ಒಪ್ಪುತ್ತೇನೆ",
    "register.consent_rec_body": "ಸಣ್ಣ ಧ್ವನಿ ಮಾದರಿಗಳು VAB ನಿಂದ ವಿಶ್ಲೇಷಿಸಲಾಗಿದೆ.",
    "register.orient_where": "ನೀವು ಈಗ ಎಲ್ಲಿದ್ದೀರಿ?", "register.orient_when": "ಇಂದಿನ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ?",
    "report.next": "ಸೂಚಿತ ಮುಂದಿನ ಹಂತ",
    "report.high_title": "ದಯವಿಟ್ಟು ಕ್ಲಿನಿಕಲ್ ತಜ್ಞರೊಂದಿಗೆ ಸಂಪರ್ಕ ಸಾಧಿಸಿ",
    "report.high_body": "ತೀವ್ರತೆಯನ್ನು ಪರಿಗಣಿಸಿ, ಕ್ಲಿನಿಕಲ್ ಸಮಾಲೋಚನೆ ಮಾತ್ರ ಸಕ್ರಿಯ.",
    "report.book_clinical": "ಕ್ಲಿನಿಕಲ್ ಸಮಾಲೋಚನೆ ಬುಕ್ ಮಾಡಿ",
    "report.speak_specialist": "ತಜ್ಞರೊಂದಿಗೆ ಮಾತನಾಡಿ", "report.browse_therapies": "ಥೆರಪಿ ಅನ್ವೇಷಿಸಿ",
    "report.open_voicelab": "Voice Lab ನಲ್ಲಿ ಮುಂದುವರಿಸಿ",
    "report.crisis": "ಬಿಕ್ಕಟ್ಟು? Vandrevala Foundation ಸಹಾಯವಾಣಿ: 1860 2662 345",
    "band.normal.title": "ಸಾಮಾನ್ಯ ವ್ಯಾಪ್ತಿಯಲ್ಲಿ",
    "band.normal.body": "ನಿಮ್ಮ ಸೂಚಕಗಳು ಸ್ಥಿರವಾಗಿವೆ. ದೈನಂದಿನ ಅಭ್ಯಾಸಗಳನ್ನು ಮುಂದುವರಿಸಿ.",
    "band.mild.title": "ಸೌಮ್ಯ ಸೂಚಕಗಳು",
    "band.mild.body": "ಸಣ್ಣ ಬದಲಾವಣೆಗಳಿಗೆ ಗಮನ ಕೊಡಿ.",
    "band.moderate.title": "ಮಧ್ಯಮ ಕಾಳಜಿ",
    "band.moderate.body": "ಕ್ಲಿನಿಕಲ್ ತಜ್ಞರೊಂದಿಗೆ ಸಮಾಲೋಚಿಸಲು ನಾವು ಶಿಫಾರಸು ಮಾಡುತ್ತೇವೆ.",
    "band.high.title": "ಹೆಚ್ಚಿನ ತೀವ್ರತೆ — ಸಹಾಯ ಪಡೆಯಿರಿ",
    "band.high.body": "ಕ್ಲಿನಿಕಲ್ ಸಮಾಲೋಚನೆ ಬುಕ್ ಮಾಡಿ. ಅಸುರಕ್ಷಿತ ಎನಿಸಿದರೆ Vandrevala ಸಹಾಯವಾಣಿ: 1860 2662 345.",
    "assess.prompt1": "ನಿಮ್ಮ ಕೆಲಸ ಹೇಗೆ ಸಾಗುತ್ತಿದೆ?",
    "assess.prompt2": "ನಿಮ್ಮ ಬಾಲ್ಯದ ನೆನಪುಗಳನ್ನು ವಿವರಿಸಿ.",
    "assess.play": "ಪ್ರಾಂಪ್ಟ್ ಕೇಳಿ",
    "assess.stop": "ನಿಲ್ಲಿಸಿ",
    "assess.read_aloud": "ಜೋರಾಗಿ ಓದಿ",
  },
  mr: {
    brand_tag: "आवाज · मन · काळजी",
    "nav.home": "मुख्यपृष्ठ", "nav.assess": "तपासणी", "nav.lab": "लॅब", "nav.experts": "तज्ज्ञ", "nav.care": "काळजी", "nav.me": "माझं पान",
    "landing.tagline": "आवाज-प्रथम मानसिक आरोग्य तपासणी",
    "landing.title": "तुमचा आवाज, तुमच्या मनाची स्थिती.",
    "landing.subtitle": "मनोदयम आवाज बायोमार्कर्स वापरून मानसिक व संज्ञानात्मक तपासणी करते.",
    "landing.cta_primary": "तपासणी सुरू करा", "landing.cta_secondary": "मला आधीच खाते आहे",
    "landing.apply_link": "तज्ज्ञ म्हणून अर्ज करा",
    "auth.login": "साइन इन", "auth.signup": "सुरू करा",
    "auth.welcome_back": "परत स्वागत", "auth.email": "ईमेल", "auth.password": "पासवर्ड",
    "auth.sign_in": "साइन इन", "auth.new_here": "नवीन आहात?", "auth.create_account": "खाते तयार करा",
    "home.greeting": "नमस्ते", "home.hero_title": "आज स्वतःशी संवाद साधण्यास तयार?",
    "home.hero_sub": "छोटा आवाज नमुना किंवा Voice Lab प्रश्नावली निवडा.",
    "home.start_voice": "आवाज तपासणी सुरू करा", "home.open_voicelab": "Voice Lab उघडा",
    "home.latest_report": "अलीकडील अहवाल", "home.view_report": "अहवाल पहा",
    "quick.assess": "आवाज मूल्यांकन", "quick.assess_sub": "30 सेकंदांचे मार्गदर्शित प्रश्न",
    "quick.voicelab": "Voice Lab", "quick.voicelab_sub": "PHQ-9 · GAD-7 · MoCA",
    "quick.experts": "क्लिनिकल तज्ज्ञ", "quick.experts_sub": "सल्ला बुक करा",
    "quick.therapies": "थेरपी व पॅकेजेस", "quick.therapies_sub": "काळजी प्रवास पहा",
    "voicelab.title": "मानकीकृत प्रश्नावली", "voicelab.subtitle": "कोणतीही प्रश्नावली पूर्ण करा.",
    "voicelab.combined": "एकत्रित Voice Lab सारांश",
    "therapies.title": "निवडक मार्ग", "therapies.subtitle": "क्लिनिकल व सहायक काळजी एकत्रित करणारे पॅकेजेस.",
    "therapies.buy": "पॅकेज खरेदी करा", "therapies.owned": "तुमच्याकडे आहे",
    "therapies.individual": "सहायक काळजी यादी",
    "experts.title": "सत्यापित तज्ज्ञ",
    "experts.subtitle": "प्रत्येक तज्ज्ञ आमच्या टीमकडून मॅन्युअली सत्यापित केला जातो.",
    "register.step1": "तुमचे खाते तयार करा", "register.step1_sub": "तुमची माहिती गोपनीय व सुरक्षित राहील.",
    "register.step2": "तुमची संमती महत्त्वाची", "register.step2_sub": "पुढे जाण्यापूर्वी पुष्टी करा.",
    "register.step3": "छोटी ओळख", "register.step3_sub": "मूल्यांकनासाठी दोन झटपट प्रश्न.",
    "register.name": "पूर्ण नाव", "register.email": "ईमेल", "register.password": "पासवर्ड (किमान 6)", "register.phone": "मोबाइल नंबर",
    "register.dob": "जन्मतारीख", "register.gender": "लिंग", "register.language": "पसंतीची भाषा",
    "register.continue": "पुढे जा", "register.back": "मागे", "register.create": "खाते तयार करा",
    "register.creating": "तयार करत आहे…",
    "register.consent_data_title": "मी डेटा संग्रहासाठी संमती देतो/देते",
    "register.consent_data_body": "तुमची प्रोफाइल व मूल्यांकन निकाल सुरक्षित संग्रहित आहेत.",
    "register.consent_rec_title": "मी आवाज रेकॉर्डिंगसाठी संमती देतो/देते",
    "register.consent_rec_body": "छोटे आवाज नमुने VAB मॉडेलने विश्लेषित केले जातात.",
    "register.orient_where": "तुम्ही सध्या कुठे आहात?", "register.orient_when": "आजची तारीख व वेळ?",
    "report.next": "सुचवलेली पुढील पायरी",
    "report.high_title": "कृपया क्लिनिकल तज्ज्ञांशी संपर्क साधा",
    "report.high_body": "गंभीरता पाहता, फक्त क्लिनिकल सल्ला सक्षम आहे.",
    "report.book_clinical": "क्लिनिकल सल्ला बुक करा",
    "report.speak_specialist": "तज्ज्ञांशी बोला", "report.browse_therapies": "थेरपी पहा",
    "report.open_voicelab": "Voice Lab मध्ये सुरू ठेवा",
    "report.crisis": "संकट? Vandrevala Foundation हेल्पलाइन: 1860 2662 345",
    "band.normal.title": "सामान्य श्रेणीत",
    "band.normal.body": "तुमचे निर्देशक स्थिर आहेत. दैनंदिन सराव सुरू ठेवा.",
    "band.mild.title": "सौम्य निर्देशक", "band.mild.body": "छोट्या बदलांकडे लक्ष द्या.",
    "band.moderate.title": "मध्यम चिंता", "band.moderate.body": "क्लिनिकल तज्ज्ञांशी सल्लामसलत करा.",
    "band.high.title": "उच्च गंभीरता — कृपया मदत घ्या",
    "band.high.body": "क्लिनिकल सल्ला बुक करा. असुरक्षित वाटल्यास Vandrevala हेल्पलाइन: 1860 2662 345.",
    "assess.prompt1": "तुमचे काम कसे चालले आहे?",
    "assess.prompt2": "तुमच्या बालपणीच्या आठवणी सांगा.",
    "assess.play": "प्रश्न ऐका",
    "assess.stop": "थांबवा",
    "assess.read_aloud": "मोठ्याने वाचा",
  },
  bn: {
    brand_tag: "কণ্ঠ · মন · যত্ন",
    "nav.home": "হোম", "nav.assess": "মূল্যায়ন", "nav.lab": "ল্যাব", "nav.experts": "বিশেষজ্ঞ", "nav.care": "যত্ন", "nav.me": "আমার পৃষ্ঠা",
    "landing.tagline": "কণ্ঠ-প্রথম মানসিক স্বাস্থ্য পরীক্ষা",
    "landing.title": "আপনার কণ্ঠস্বর, আপনার মনের অবস্থা।",
    "landing.subtitle": "মনোদয়ম কণ্ঠ বায়োমার্কার ব্যবহার করে মানসিক ও জ্ঞানীয় স্ক্রিনিং করে।",
    "landing.cta_primary": "স্ক্রিনিং শুরু করুন", "landing.cta_secondary": "আমার ইতিমধ্যে অ্যাকাউন্ট আছে",
    "landing.apply_link": "বিশেষজ্ঞ হিসাবে আবেদন করুন",
    "auth.login": "সাইন ইন", "auth.signup": "শুরু করুন",
    "auth.welcome_back": "আবার স্বাগতম", "auth.email": "ইমেল", "auth.password": "পাসওয়ার্ড",
    "auth.sign_in": "সাইন ইন", "auth.new_here": "নতুন এসেছেন?", "auth.create_account": "অ্যাকাউন্ট তৈরি করুন",
    "home.greeting": "নমস্তে", "home.hero_title": "আজ নিজের সঙ্গে দেখা করতে প্রস্তুত?",
    "home.hero_sub": "একটি ছোট কণ্ঠ নমুনা বা Voice Lab প্রশ্নপত্র বেছে নিন।",
    "home.start_voice": "কণ্ঠ স্ক্রিনিং শুরু করুন", "home.open_voicelab": "Voice Lab খুলুন",
    "home.latest_report": "সাম্প্রতিক রিপোর্ট", "home.view_report": "রিপোর্ট দেখুন",
    "quick.assess": "কণ্ঠ মূল্যায়ন", "quick.assess_sub": "30 সেকেন্ডের নির্দেশিত প্রশ্ন",
    "quick.voicelab": "Voice Lab", "quick.voicelab_sub": "PHQ-9 · GAD-7 · MoCA",
    "quick.experts": "ক্লিনিক্যাল বিশেষজ্ঞ", "quick.experts_sub": "পরামর্শ বুক করুন",
    "quick.therapies": "থেরাপি ও প্যাকেজ", "quick.therapies_sub": "যত্ন যাত্রা অন্বেষণ করুন",
    "voicelab.title": "মানসম্মত প্রশ্নপত্র", "voicelab.subtitle": "যেকোনো প্রশ্নপত্র সম্পূর্ণ করুন।",
    "voicelab.combined": "সম্মিলিত Voice Lab সারসংক্ষেপ",
    "therapies.title": "নির্বাচিত পথ", "therapies.subtitle": "ক্লিনিক্যাল ও সহায়ক যত্ন একত্রিত করা প্যাকেজ।",
    "therapies.buy": "প্যাকেজ কিনুন", "therapies.owned": "আপনার আছে",
    "therapies.individual": "সহায়ক যত্ন তালিকা",
    "experts.title": "যাচাইকৃত বিশেষজ্ঞ",
    "experts.subtitle": "প্রত্যেক বিশেষজ্ঞকে আমাদের দল ম্যানুয়ালি যাচাই করে।",
    "register.step1": "আপনার অ্যাকাউন্ট তৈরি করুন", "register.step1_sub": "আপনার তথ্য গোপন ও নিরাপদ থাকে।",
    "register.step2": "আপনার সম্মতি গুরুত্বপূর্ণ", "register.step2_sub": "এগিয়ে যাওয়ার আগে নিশ্চিত করুন।",
    "register.step3": "ছোট পরিচিতি", "register.step3_sub": "মূল্যায়নের জন্য দুটি দ্রুত প্রশ্ন।",
    "register.name": "পুরো নাম", "register.email": "ইমেল", "register.password": "পাসওয়ার্ড (কমপক্ষে 6)", "register.phone": "মোবাইল নম্বর",
    "register.dob": "জন্ম তারিখ", "register.gender": "লিঙ্গ", "register.language": "পছন্দের ভাষা",
    "register.continue": "চালিয়ে যান", "register.back": "পিছনে", "register.create": "অ্যাকাউন্ট তৈরি করুন",
    "register.creating": "তৈরি করা হচ্ছে…",
    "register.consent_data_title": "আমি ডেটা সংগ্রহে সম্মতি দিচ্ছি",
    "register.consent_data_body": "আপনার প্রোফাইল ও মূল্যায়ন ফলাফল নিরাপদে সংরক্ষিত।",
    "register.consent_rec_title": "আমি কণ্ঠ রেকর্ডিংয়ে সম্মতি দিচ্ছি",
    "register.consent_rec_body": "ছোট কণ্ঠ নমুনা VAB মডেল দ্বারা বিশ্লেষণ করা হয়।",
    "register.orient_where": "আপনি এখন কোথায় আছেন?", "register.orient_when": "আজকের তারিখ ও সময় কী?",
    "report.next": "প্রস্তাবিত পরবর্তী পদক্ষেপ",
    "report.high_title": "অনুগ্রহ করে ক্লিনিক্যাল বিশেষজ্ঞের সঙ্গে যোগাযোগ করুন",
    "report.high_body": "গুরুত্ব বিবেচনা করে, শুধুমাত্র ক্লিনিক্যাল পরামর্শ সক্রিয়।",
    "report.book_clinical": "ক্লিনিক্যাল পরামর্শ বুক করুন",
    "report.speak_specialist": "বিশেষজ্ঞের সঙ্গে কথা বলুন", "report.browse_therapies": "থেরাপি দেখুন",
    "report.open_voicelab": "Voice Lab-এ চালিয়ে যান",
    "report.crisis": "সংকট? Vandrevala Foundation হেল্পলাইন: 1860 2662 345",
    "band.normal.title": "স্বাভাবিক পরিসরে",
    "band.normal.body": "আপনার সূচকগুলি স্থির। দৈনন্দিন অভ্যাস চালিয়ে যান।",
    "band.mild.title": "হালকা সূচক", "band.mild.body": "ছোট পরিবর্তনগুলিতে মনোযোগ দিন।",
    "band.moderate.title": "মাঝারি উদ্বেগ", "band.moderate.body": "ক্লিনিক্যাল বিশেষজ্ঞের সঙ্গে পরামর্শ করুন।",
    "band.high.title": "উচ্চ গুরুত্ব — সাহায্য নিন",
    "band.high.body": "ক্লিনিক্যাল পরামর্শ বুক করুন। অনিরাপদ বোধ করলে Vandrevala হেল্পলাইন: 1860 2662 345.",
    "assess.prompt1": "আপনার কাজ কেমন চলছে?",
    "assess.prompt2": "আপনার শৈশবের স্মৃতিগুলি বর্ণনা করুন।",
    "assess.play": "প্রম্পট শুনুন",
    "assess.stop": "থামান",
    "assess.read_aloud": "জোরে পড়ুন",
  },
};

export function getBundle(code) {
  return B[code] || B.en;
}

export function tKey(code, key) {
  const bundle = getBundle(code);
  const en = B.en;
  return bundle[key] ?? en[key] ?? key;
}
